(async () => {
  const {
    updateURLParams,
    historyPush,
    parseHTML
  } = await import(window.theme.modules.utils);
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define('product-form', class extends baseComponent.default {
    elements = {
      form: 'form',
      addButton: '[data-add-button]',
      buyButton: '[data-buy-button]',
      soldOutButton: '[data-sold-out-button]',
      input: '[data-variant-id-input]',
      sellingPlanInput: 'input[name="selling_plan"]'
    };
    
    async render() {
      this._enableInput();
      this.cartSection = document.querySelector('main-cart');
      this.isProductPage = this.getAttribute('page-type') === 'product';
      
      // Initialize Appstle selling plan capture
      this.getAppstleSellingPlan = this._captureAppstleSellingPlan();
      
      this.listenTo('variantChange', (e, data) => {
        this._rerender(data);
        if (data.variant) {
          this._rerenderVariantInput(data)
        }
      });
      this.on('cartChange', (e, data) => {
        this._updateQtyStatus(data.variantId)
      }, false)
      if (this.hasAttribute('cart-popup'))
        this.$form.addEventListener('submit', this._handleSubmit.bind(this));
      
      if (this.$sellingPlanInput && this.hasAttribute('selling-plan-enable')) {
        this.currentSellingPlanId = this.querySelector('input[name="selling_plan"]').value;
        const {observeInputValueChange} = await import(window.theme.modules.sellingPlanUtil);
        observeInputValueChange(this.$sellingPlanInput, this._handleSellingPlanChange.bind(this));
      }
    };
    
  _captureAppstleSellingPlan() {
  let appstleSellingPlan = null;
  
  // Listen for Appstle subscription selection
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', () => {
    const selectedPlan = jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val();
    // Convert to integer to ensure proper format
    appstleSellingPlan = selectedPlan ? parseInt(selectedPlan, 10) : null;
    console.log('Appstle selling plan SELECTED:', appstleSellingPlan);
  });
  
  // Listen for Appstle subscription deselection
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', () => {
    appstleSellingPlan = null;
    console.log('Appstle selling plan DESELECTED - cleared');
  });
  
  // Also check on page load if a plan is already selected
  const initialPlan = jQuery('.appstle_sub_widget input[name=selling_plan]:checked').val();
  if (initialPlan) {
    appstleSellingPlan = parseInt(initialPlan, 10);
  }
  
  return () => appstleSellingPlan;
};
    
    _handleSellingPlanChange(newSellingPlanId) {
      if (newSellingPlanId === this.currentSellingPlanId) 
        return;      
      this.currentSellingPlanId = newSellingPlanId;
      const { queryURL, currentURL } = updateURLParams({ 'selling_plan': this.currentSellingPlanId, 'variant': this.getAttribute('current-variant') }, this.sectionId);
      if (this.isProductPage)
        historyPush(currentURL);
      this._fetchPageWithVariant(queryURL, html => {
        this.forwardEvent('sellingPlanChange', {
          html: html
        })
      }); 
    };

    _enableInput() {
      this.$input.disabled = false;
    }
    
    _fetchPageWithVariant(url, onResponse) {
      return fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = parseHTML(responseText)
        onResponse(html);
      });
    };

    _rerender(data) {
      const isHiddenAddBtn = data.html.querySelector('[data-add-button]').hasAttribute('hidden');
      const isHiddenSoldOutBtn = data.html.querySelector('[data-sold-out-button]').hasAttribute('hidden');
      this.$addButton.toggleAttribute('hidden', isHiddenAddBtn);
      this.$buyButton?.toggleAttribute('hidden', isHiddenAddBtn);
      this.$soldOutButton.toggleAttribute('hidden', isHiddenSoldOutBtn);
    };
    
    _rerenderVariantInput(data) {
      this.setAttribute('current-variant', `${data.variant.id}`);
      const value = data.html.querySelector(this.elements.input).value;
      this.$input.value = value;
    };

    _handleSubmit(e) {
      e.preventDefault();
      
      /* console.log('=== FORM SUBMIT TRIGGERED ==='); */
      
      // CHECK FOR VARIANT GRID SELECTIONS
      const variantGrid = document.querySelector('[data-variant-grid]');
      console.log('Variant grid found:', variantGrid);
      
      if (variantGrid) {
        const gridItems = this._getVariantGridItems(variantGrid);
        console.log('Grid items found:', gridItems);
        
        if (gridItems.length > 0) {
          console.log('Using variant grid items');
          // Use variant grid items instead
          this._addVariantGridToCart(gridItems);
          return;
        } else {
          console.log('No grid items selected, using default form');
        }
      } else {
        console.log('No variant grid on page, using default form');
      }
      
      // Default behavior: use form data
      this.formData = new FormData(e.target);
      this._addToCartRequest();
    };
    
    // Get variant grid selections
    _getVariantGridItems(variantGrid) {
      const items = [];
      const qtyInputs = variantGrid.querySelectorAll('.variant-qty-input');
      
      qtyInputs.forEach(input => {
        const qty = parseInt(input.value) || 0;
        if (qty > 0) {
          items.push({
            id: input.dataset.variantId,
            quantity: qty
          });
        }
      });
      
      return items;
    };
    
    // Add variant grid items to cart with Appstle selling plan support
    _addVariantGridToCart(items) {
      this._setLoading(true);
      
      // Get the current Appstle selling plan (if any)
      const sellingPlan = this.getAppstleSellingPlan();
      
      // Add selling plan to each item if one is selected
      const itemsWithSellingPlan = items.map(item => {
        if (sellingPlan) {
          return {
            ...item,
            selling_plan: sellingPlan
          };
        }
        return item;
      });
      
      console.log('Items being added to cart:', itemsWithSellingPlan);
      
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: itemsWithSellingPlan })
      })
      .then(res => res.json())
      .then((data) => {
        console.log('Variant grid items added:', data);
        
        // Reset variant grid quantities
        const variantGrid = document.querySelector('[data-variant-grid]');
        if (variantGrid) {
          const qtyInputs = variantGrid.querySelectorAll('.variant-qty-input');
          qtyInputs.forEach(input => input.value = 0);
          
          // Update total price display
          const totalPriceEl = variantGrid.querySelector('[data-total-price]');
          if (totalPriceEl) {
            totalPriceEl.textContent = '$0.00';
          }
        }
        
        this.trigger('updateCart', {
          callback: () => {
            this._setLoading(false);
            if(this.cartSection) {
              this.cartSection.update();
            } else {
              this.trigger('openPopup', { target: 'CART' });
            }
          }
        })
      })
      .catch(error => {
        this._setLoading(false);
        console.error('Error adding variant grid to cart:', error);
      });
    };

    _addToCartRequest() {
      this._setLoading(true);
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
          "Accept": "application/javascript"
        },
        body: this.formData
      })
      .then(res => {
        return res.json();
      })
      .then(() => {
        this.trigger('updateCart', {
          callback: () => {
            this._setLoading(false);
            this._updateQtyStatus(this.formData.get('id'));
            if(this.cartSection) {
              this.cartSection.update();
            } else {
              this.trigger('openPopup', { target: 'CART' });
            }
          }
        })
      })
      .catch(error => {
        this._setLoading(false);
        console.log(error);
      });
    };

    _updateQtyStatus(variantId) {
      const url = `${this.getAttribute('product-url')}?variant=${variantId}&section_id=${this.getAttribute('section-id')}`;
      this._fetchPageWithVariant(url, html => {
        this.trigger('qtyStatusUpdate', {html: html, variantId: variantId})
        this._rerender({html: html})
      })
    };
    
    _setLoading(status) {
      status 
        ? this.$addButton.setAttribute('loading', '')
        : this.$addButton.removeAttribute('loading');
    };
  });
})();
